module.exports = __webpack_public_path__ + "media/images/flags/16/Uruguay-f1fdc2213bda0d6d67102088c8ff7937.png";